<script setup>
import { RouterLink } from 'vue-router'
defineProps({
  sectiontitle: String,
  sectioncta: String,
  sectionsecondcta: String,
  sectionsecondctalink: String,
  sectiondescription: String,
})
</script>
<template>
  <section id="contact"
    class="relative mt-40 bg-gradient-to-r from-accent1/10 to-accent1/20 md:h-[50vh] flex flex-col items-center justify-center overflow-hidden max-md:py-40">
    <div class="relative text-center 2xl:w-8/12 lg:w-10/12 w-11/12 z-[1] px-6 space-y-6">
      <h1 v-if="sectiontitle" class=" text-accent1 2xl:text-4xl lg:text-3xl md:text-2xl text-[30px] text-center
        font-[400] mb-10">{{ sectiontitle }}</h1>
      <p class="tracking-wide font-[200] max-sm:text-[14px] text-accent2 2xl:w-5/12 sm:w-2/3 mx-auto text-justify"
        style="text-align-last: center">{{ sectiondescription }}</p>
      <div class="flex flex-col items-center justify-center gap-6 sm:flex-row">
        <component v-if="sectionsecondcta" :is="sectionsecondctalink?.startsWith('http') ? 'a' : RouterLink"
          :to="!sectionsecondctalink?.startsWith('http') ? sectionsecondctalink : undefined"
          :href="sectionsecondctalink?.startsWith('http') ? sectionsecondctalink : undefined" target="_blank"
          rel="noopener noreferrer" id="go-to-contact-page" aria-label="go to contact page"
          class="block w-fit cursor-pointer px-4 py-3 max-sm:text-[14px] font-[200] text-center rounded-[8px] text-accent1 bg-bg2 hover:brightness-125 transition-all duration-400">
          {{ sectionsecondcta }}
        </component>

        <RouterLink id="go-to-contact-page" aria-label="go to contact page" to="/contact"
          class="block w-fit cursor-pointer px-4 py-3 max-sm:text-[14px] font-[200] text-center rounded-[8px] text-accent1 bg-bg2 hover:brightness-125 transition-all duration-400">
          {{ sectioncta }}</RouterLink>
      </div>
    </div>
    <!-- Highlights -->
    <!-- left -->
    <img src="/images/testimonies/contact/elements/leftmiddle.svg" alt="AITS" width="513" height="631" center cover
      responsive loading="lazy" class="absolute top-0 transform lg:-translate-y-1/2 2xl:left-0 lg:top-1/2 -left-10" />
    <!-- center middle -->
    <img src="/images/testimonies/contact/elements/centermiddle.svg" alt="AITS" width="345" height="338" center cover
      responsive loading="lazy" class="absolute transform -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2" />
    <!-- right -->
    <img src="/images/testimonies/contact/elements/rightmiddle.svg" alt="AITS" width="767" height="699" center cover
      responsive loading="lazy"
      class="absolute top-[100%] transform lg:-translate-y-1/2 -translate-y-[100%] 2xl:right-0 lg:top-1/2 -right-1/4" />
    <img src="/images/testimonies/contact/elements/rightbottom.svg" alt="AITS" width="287" height="315" center cover
      responsive loading="lazy" class="absolute 2xl:right-0 top-[100%] transform -translate-y-[100%] -right-1/4" />
  </section>
</template>
